import { Suspense } from 'react';
import { Skeleton } from '@mui/material';

export const ControlSuspense = ({ children, skeletonProps }) => {
  return <Suspense fallback={<Skeleton variant="rounded" height={50} {...skeletonProps} />}>{children}</Suspense>;
};
